import { useQuery } from "@tanstack/react-query";
import { useAppService } from "../../../use-app-service";
import { nominatedPurchasersKeys } from "../../query-keys";

export const useGetNominatedPurchaserDetailsViewQuery = (
  nominatedPurchaserId?: string,
) => {
  const service = useAppService();
  return useQuery({
    queryKey: nominatedPurchasersKeys.getNominatedPurchaserDetailsView(
      nominatedPurchaserId ?? "<>",
    ),
    queryFn: () =>
      nominatedPurchaserId == null
        ? Promise.reject(new Error("No nominated purchaser"))
        : service
            .getNominatedPurchaserDetailsView({ nominatedPurchaserId })
            .then((x) => {
              if (x == null) throw new Error("No details exist");
              return x;
            }),
  });
};
